export default "__VITE_ASSET__Cl9uCr6D__"